import React, { useEffect, useState } from 'react'
import { AiOutlineAppstoreAdd, AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai'
import { MdDone } from 'react-icons/md'
import { Outlet, Link } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';


interface Props {
  group: Group,

}

interface Group {
  name: string,
  id: number,
  isDone: boolean
}



const AllGroups: React.FC<Props> = ({ group }) => {

  const [addOption, setAddOption] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [editNameGroup, setEditNameGroup] = useState<string>(group.name)

  const addOptions = () => {
    setAddOption(true);
  }

  const handleDone = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    let year = new Date().getFullYear();
    let date = `${month}/${day}/${year}`;
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie przeniesiony do zakończonych",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/doneGroup', {
          id: id,
          isDone: 1,
          date: date,
        })
      }
    })
      .then((response) => {
      })
      .catch(function (error) {
        console.log("error!")
      })
  }
  const handleDelete = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie na zawsze usunięty.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteGroup', {
          id: id,
        })
        axios.post(ipAddress + '/deleteTask2', {
          id:id,
        })
      }
    })
      .then((response) => {
      })
      .catch(function (error) {
        console.log("error!")
      })

  }
  const editGroup = () => {
    setEdit(true);
    setAddOption(false);
  }

  const handleEdit = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    axios.post(ipAddress + '/editNameGroup', {
      id: id,
      nameGroup: editNameGroup,
    })
      .then((response) => {

      })

      .catch(function (error) {
        console.log("error!")

      })
    setEdit(false);

  }

const editName = () => {
  setEdit(false);
  setEditNameGroup(group.name)
}




  return (
    <div>
      <div className='allGroups'>
        <Link to='/ToDo/One' state={{ from: group }} id='name' >{group.name}</Link>
        
        <span className='icon' onClick={() => addOptions()} ><AiOutlineAppstoreAdd /></span>

        {addOption ? (
          <div className='addOption'>
            <p>{group.name}</p>
            <p onClick={(e) => handleDone(e, group.id)} ><MdDone /><span>Zakończ</span></p>
            <p onClick={(e) => handleDelete(e, group.id)} ><AiFillDelete /><span>Usuń</span></p>
            <p onClick={() => editGroup()}><AiFillEdit /><span>Edytuj</span></p>
            <button onClick={() => setAddOption(false)}>Cancel</button>
          </div>

        ) : (
          <div></div>
        )
        }
      </div>
      {edit ? (
        <form className='editGroup' onSubmit={(e) => { handleEdit(e, group.id) }}>
          <span className='icon' id='close' onClick={() => editName()} ><AiOutlineClose /></span>
          <p>Edytuj nazwe grupy</p>
          <div className='nameGroup'>
            <label htmlFor="nameGroup">Nazwa: </label>
            <input type="input"
              id='nameGroup'
              value={editNameGroup}
              onChange={(e) => setEditNameGroup(e.target.value)}
            ></input>
          </div>

          <button type='submit'>OK</button>
        </form>
      ) : (
        <div></div>
      )
      }

      <Outlet />

    </div>
  )
}

export default AllGroups